<template lang="pug">
include /../../s-pug/mixin-icon
MakerAdminLayout(accountPageHeading="Manage team")
   ._mb4(v-if="teamProfile && teamProfile.data")
      ._mb3
         AccountPanelHeading(heading="Team profile")
         ._border._bg-white._boxShadow._radius._pb1-5(v-if="teamProfile")
            ._flex._flex-alignItemsCenter._flex-noShrink._px1-5._pt1-5
               //- TODO: Fix this not updating after updating the profile (it's a caching bug).
               ._c-grey-600(style="width: 150px;") First published:
               ._bold._c-grey-700(v-if="teamProfile.data.firstPublishTs") {{teamProfile.data.firstPublishTs | defaultDateTime}}
               ._bold._c-grey-400(v-if="!teamProfile.data.firstPublishTs") (not yet published)
            ._flex._flex-alignItemsCenter._flex-noShrink._px1-5._pt1-5
               //- TODO: Fix this not updating after updating the profile (it's a caching bug).
               ._c-grey-600(style="width: 150px;") Last updated:
               ._bold._c-grey-700 {{teamProfile.ts | defaultDateTime}}
            ._flex._flex-alignItemsCenter._flex-noShrink._px1-5._pt1-5
               ._c-grey-600(style="width: 150px;") Status:
               ._bold._c-grey-700 {{teamProfile.data.state}}
            ._px1-5._pt2
               a.Btn.Btn--white._mr1(:href="`${env.wwwUrl}/${teamProfile.data.slug.current}/`") View
               router-link.Btn.Btn--white(:to="`/${teamProfile.data.slug.current}/edit/`") Edit
      //- ----------------------------------------------------------------
      //- Team info
      //- ----------------------------------------------------------------
      ._mb3
         AccountPanelHeading(heading="Team info")
         //- ._border._bg-white._boxShadow._radius._pb2(v-if="team")
         ._border._bg-white._boxShadow._radius._pb1-5(v-if="teamProfile")
            div(v-if="!editMode")
               ._flex._flex-alignItemsCenter._flex-noShrink._px1-5._pt1-5
                  ._c-grey-600(style="width: 150px;") Team name/type:
                  ._bold._c-grey-700 {{teamProfile.teamResolved.data.name}}
               ._flex._flex-alignItemsCenter._flex-noShrink._px1-5._pt1-5
                  ._c-grey-600(style="width: 150px;") Profile URL:
                  ._bold._c-grey-700 https://www.remotefit.com/{{teamProfile.data.slug.current}}
               ._flex._flex-alignItemsCenter._flex-noShrink._px1-5._pt1-5
                  ._c-grey-600(style="width: 150px;") Created:
                  ._bold._c-grey-700 {{teamProfile.teamResolved.data.createdAt | defaultDateTime}}
               //- TODO: This condition is never being met, since the timestamps are in different formats.
               //- ._flex._flex-alignItemsCenter._flex-noShrink._px1-5._pt1-5(v-if="teamProfile.teamResolved.data.createdAt !== teamProfile.teamResolved.ts")
               ._flex._flex-alignItemsCenter._flex-noShrink._px1-5._pt1-5
                  ._c-grey-600(style="width: 150px;") Last updated:
                  ._bold._c-grey-700 {{teamProfile.teamResolved.ts | defaultDateTime}}
               //- ._mt2._px1-5
                  button.Btn.Btn--white.Btn--sm(type="button" v-on:click="editTeamInfo('ref-teamNameInput')") Edit team info
            //- form(v-if="editMode" @submit.prevent="handleSubmit")
               div
                  label.Label._flex._flex-alignItemsCenter._flex-noShrink._pl2._pr075._pt075
                     .LabelText._mb0._c-grey-700(style="width: 200px") Team name:
                     input.Input(ref="ref-teamNameInput" type="text" v-model.trim="teamInfoFormState.name || team.data.name")
               div
                  label.Label._flex._flex-alignItemsCenter._flex-noShrink._pl2._pr075._pt075
                     .LabelText._mb0._c-grey-700(style="width: 200px") Company name:
                     input.Input(type="text" v-model.trim="teamInfoFormState.nameCompany || team.data.nameCompany")
               ._mt2._px1-5
                  button.Btn.Btn--green._px3._mr1(type="submit") Save
                  button.Btn.Btn--white(type="button" v-on:click="editMode = false") Cancel
      //- ----------------------------------------------------------------
      //- Team users
      //- ----------------------------------------------------------------
      ._mb3
         AccountPanelHeading(heading="Team users")
         ._relative._border._bg-white._boxShadow._radius._pb2(style="min-height: 80px")
            Loading(v-if="isMakersLoading")
            div(v-if="!isMakersLoading")
               ._flex._flex-wrap._flex-alignItemsCenter._px1-5._py1-5._borderBottom-default._borderColor-grey-200(v-for="maker in teamProfile.teamResolved.makersResolved") {{maker.data.email}}
            ._mt2._px1-5
               router-link.Btn.Btn--white.Btn--sm(type="button" to="") 
                  ._flex._flex-alignItemsCenter._flex-noShrink
                     ._fs-3._mr1 +
                     div Add user
      //- ----------------------------------------------------------------
      //- Team plan
      //- ----------------------------------------------------------------
      ._mb3
         AccountPanelHeading(heading="Team plan")
         ._border._bg-white._boxShadow._radius._pb2(v-if="teamProfile")
            ._pt2._px1-5
               ._mb1._ls-05._c-grey-700 Plan for {{teamProfile.teamResolved.data.name}}
            ._pt2._px1-5(v-if="!teamProfile.teamResolved.data.plan") 
               ._c-grey-600 You have not yet selected a plan.
            ._mt2._px1-5
               button.Btn.Btn--white.Btn--sm(type="button") Change plan
      //- ----------------------------------------------------------------
      //- Payment methods
      //- ----------------------------------------------------------------
      ._mb3
         AccountPanelHeading(heading="Payment methods")
         ._border._bg-white._boxShadow._radius._pb2(v-if="teamProfile")
            ._pt2._px1-5(v-if="!teamProfile.teamResolved.data.paymentMethod") 
               ._c-grey-600 You do not yet have any payment methods.
            ._mt2._px1-5
               button.Btn.Btn--white.Btn--sm(type="button") 
                  ._flex._flex-alignItemsCenter._flex-noShrink
                     ._fs-3._mr1 +
                     div Add payment method
      //- ----------------------------------------------------------------
      //- Team billing
      //- ----------------------------------------------------------------
      ._mb3
         AccountPanelHeading(heading="Billing history")
         ._border._bg-white._boxShadow._radius._pb2
            ._pt2._px1-5
               ._c-grey-600 Billing history
      //- ----------------------------------------------------------------
      //- Danger zone
      //- ----------------------------------------------------------------
      div
         AccountPanelHeading(heading="Delete team")
         ._relative
            ._border._bg-white._boxShadow._radius._pb2._relative
               Loading(v-if="deletingTeam")
               ._pt2._px1-5
                  ._c-grey-600._mb075 
                     | This 
                     span._bold cannot 
                     | be undone.
                  ._c-grey-600 
                     | Deleting your team will delete its account and profile. This will not delete 
                     span._italic your 
                     | account.
               ._mt2._px1-5
                  button.Btn.Btn--red.Btn--sm(type="button" @click="showDeleteTeamConfirmation = true") Delete team
               .Underlay._absolute._bg-white._alpha-80._radius._cursor-default(v-if="showDeleteTeamConfirmation")
            //- Confirmation overlay
            ._absolute._z100._lr0._mx-auto._bg-white._p1-5._radius._boxShadow2(style="top: -20px; bottom: -20px; max-width: 400px" v-if="showDeleteTeamConfirmation")
               ._mb2
                  ._flex._flex-justifySpaceBetween
                     ._bold._mb1
                        | This will delete the team: {{teamProfile.teamResolved.data.name}}
                     button.Btn.Btn--white._p025.IconWrap._relative(style="width: 40px; height: 40px; right: -10px; top: -10px" type="button" @click="showDeleteTeamConfirmation = false")
                        +icon({grow: true, name: "icon-x"})._c-grey-800
                  ._c-grey-600._mb1
                     | This 
                     span._bold cannot 
                     | be undone.
                  ._c-grey-600 Are you sure you want to do this?
               ._t-center
                  button.Btn.Btn--red.Btn--sm(type="button" @click="deleteTeam()") Yes, I'm sure. Delete team.
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import MakerAdminLayout from '~/layouts/MakerAdmin.vue'
import AccountPanelHeading from '~/components/AccountPanelHeading.vue'
import * as faunaQueries from '~/faunaQueries.js'
import env from '~/env'

export default {
   components: {
      MakerAdminLayout,
      AccountPanelHeading,
   },
   data() {
      return {
         env,
         editMode: false,
         isMakersLoading: false,
         teamProfileSlug: this.$route.params.companySlug + '/' + this.$route.params.teamSlug,
         teamProfile: null,
         showDeleteTeamConfirmation: false,
         deletingTeam: false,
      }
   },
   computed: {
      ...mapState(['makerState']),
   },
   methods: {
      maybeLoadMembers() {
         if (!this.teamProfile.teamResolved.makersResolved) {
            this.isMakersLoading = true
            return this.$store.dispatch('fetchMakerTeamMembers', this.teamProfile.teamResolved).then(() => {
               this.isMakersLoading = false
            })
         }
      },
      deleteTeam() {
         this.deletingTeam = true
         return this.$store
            .dispatch('deleteMakerTeam', { company: this.teamProfile.companyResolved, team: this.teamProfile.teamResolved })
            .finally(() => {
               this.deletingTeam = false
            })
      },
      handleMounted() {
         this.teamProfile = this.$store.getters.getTeamProfileBySlug(this.teamProfileSlug)
         this.maybeLoadMembers()
      },
   },
   mounted() {
      this.handleMounted()
   },
   beforeRouteUpdate(to, from, next) {
      // Force the component to re-render.
      // https://router.vuejs.org/guide/essentials/dynamic-matching.html#reacting-to-params-changes
      this.teamProfileSlug = this.$route.params.companySlug + '/' + this.$route.params.teamSlug
      this.handleMounted()
      next()
   },
}
</script>
